import React from 'react';
import Config from '../shared/Config';
import { daysAgo } from './utils';
import useStatusApi, { normalizeStatusApiError } from './useStatusApi';

const { apiBaseUrl } = Config();

export default function useIncidents(useFilter = true, incidentId = null, severity = null) {
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const { ready, get } = useStatusApi();

  React.useEffect(() => {
    if (!ready) return undefined;
    let cancelled = false;
    const endpointUrl = severity === null ? `${apiBaseUrl}/incidents` : `${apiBaseUrl}/incident/${incidentId}`;

    setLoading(true);
    setError(null);
    get(endpointUrl, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (cancelled) return;
        const incidents = response.data.data.attributes.incidents;
        const nextItems = useFilter
          ? incidents.filter((incident) => {
              const { created } = incident.data.attributes;
              return Number(daysAgo(created)) < 11;
            })
          : incidents;
        setItems(nextItems);
        setLoading(false);
      })
      .catch((requestError) => {
        if (cancelled) return;
        setError(normalizeStatusApiError(requestError));
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [get, incidentId, ready, severity, useFilter]);

  return { loading, items, error };
}
